module.exports = __webpack_public_path__ + "static/media/bi_symbol_initial_black_m.20b17cb0.png";